import { useTranslation } from 'react-i18next';
import { Box, Container, Typography } from '@mui/material';
import Page from '../../components/Page';
import AttendanceForm from '../../sections/@dashboard/attendances/AttendanceForm';

// ---------------------------------------------------------------------

export default function SaveAttendance() {
  const { t } = useTranslation();

  return (
    <Page title={t('attendance_form')}>
      <Container maxWidth="xl">
        <Typography variant="h4" fontWeight={800} gutterBottom mb={4}
          sx={{ color: '#032C65' }}
        >
          {t('new_attendance')}
        </Typography>
        <Box sx={{ background: '#fff', borderRadius: 3, p: { xs: 2, md: 4 }, boxShadow: '0 1px 8px 0 rgba(3,44,101,0.07)' }}>
          <AttendanceForm />
        </Box>
      </Container>
    </Page>
  );
}